import { Controller } from "stimulus";

export default class extends Controller {

    connect() {
        this.disableHistoryBack();
    }

    disconnect() {
        this.enableHistoryBack();
    }

    disableHistoryBack() {
        history.pushState(null, document.title, location.href);
        window.addEventListener('popstate', this.blockOldHistory);
    }

    enableHistoryBack() {
        window.removeEventListener('popstate', this.blockOldHistory);
    }

    blockOldHistory(event) {
        history.pushState(null, document.title, location.href);
    }

}